// import { ControlledEditor, monaco } from '@monaco-editor/react';

// import monaco from '@monaco-editor/loader';

import React from 'react';

import ReactMonacoEditor from 'react-monaco-editor';
import { KeyCode, KeyMod } from 'monaco-editor';
import { getValueFromObjectUsingPath } from '../../services/formDataServices';
import { deepCopy } from './formFunctions';
import { substitute } from '../../services/stringsubstitutions';

// Custom worker loader
// eslint-disable-next-line no-restricted-globals
// self.MonacoEnvironment = {
//   getWorker: function (_, label) {
//     switch (label) {
//       case 'json':
//         return new Worker('monaco-editor/esm/vs/language/json/json.worker.js', { type: 'module' });
//       case 'css':
//       case 'scss':
//       case 'less':
//         return new Worker('monaco-editor/esm/vs/language/css/css.worker.js', { type: 'module' });
//       case 'html':
//       case 'handlebars':
//       case 'razor':
//         return new Worker('monaco-editor/esm/vs/language/html/html.worker.js', { type: 'module' });
//       case 'typescript':
//       case 'javascript':
//         return new Worker('monaco-editor/esm/vs/language/typescript/ts.worker.js', { type: 'module' });
//       default:
//         return new Worker('monaco-editor/esm/vs/editor/editor.worker.js', { type: 'module' });
//     }
//   }
// };

export class FormEditor extends React.Component {
    constructor(props) {
        super(props);

        this.handleEditorValueChange = this.handleEditorValueChange.bind(this);
        this.resize = this.resize.bind(this);
        this.state = {};
        // Create a ref for the Monaco Editor
        this.editorRef = React.createRef();
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    resize(val) {
        // clearTimeout(this.resizeTimeout);
        // this.resizeTimeout = setTimeout(() => {

        //     if (this.editor) {
        //         this.editor.layout();
        //     }
        // }, 200);        
        if (this.editor) {
            this.editor.layout();
        }      
    }

    componentDidUpdate() {
        var { formGenerator, field } = this.props;
        var page = this.getPage();

        if (this.state.currentPage !== page) {
            if (!field.property) return;

            formGenerator.getFormData()[field.property] = page;
            this.setState({ currentPage: page });

            if (this.editor) {
                // clears the undo stack
                // var editorModal = this.editor.getModel();
                // editorModal.setValue(page);
            }

            var formData = formGenerator.getFormData();
            formData[field.property] = page;
            formData[field.property + 'IsDirty'] = false;
            formGenerator.updateFormData(formData);

            // HACK to get intellisense working correctly
            if (formData?.resourcePath != null) {
                // Community Id
                if (formData?.resourcePath.indexOf('environments') === 0) {
                    this.editor.getModel().id = substitute(
                        // eslint-disable-next-line no-template-curly-in-string
                        'community_dev_${selectedRow.serviceId}',
                        formGenerator.props.controller,
                        [formGenerator.getFormData()]
                    );
                } else {
                    // servive id
                    this.editor.getModel().id =
                        'subdomains_' + formData?.resourcePath.replace('/services/', '_').replace('/websites/', '_');
                }
            }
        }
    }

    getPage() {
        var { formGenerator, field } = this.props;

        var value =
            field.key.indexOf('ds.') === 0
                ? getValueFromObjectUsingPath(formGenerator.props.dataStore, field.key)
                : getValueFromObjectUsingPath(formGenerator.getFormData(), field.key);

        setTimeout(() => {
            if (field.settings.gotoLine) {
                // var goToLine = (lineNumber) => {
                //     this.editor.revealLine(lineNumber); // Scrolls to the line
                //     this.editor.setPosition({ lineNumber: lineNumber, column: 1 }); // Moves cursor
                //     this.editor.focus(); // Puts focus on the editor
                // };
                var phrase = substitute(field.settings.phrase, formGenerator.props.controller, [formGenerator.getFormData()]);
                var lineNo = substitute(field.settings.gotoLine, formGenerator.props.controller, [formGenerator.getFormData()]);
                this.editor.goToLineAndHighlightPhrase(parseInt(lineNo), phrase);
                // this.editor.selectPhrase(phrase, parseInt(lineNo));
                // this.editor.goToLine(parseInt(lineNo));
            }
        }, 20);

        return value;
    }

    handleEditorValueChange(newValue) {
        var { formGenerator, field } = this.props;
        if (field.property) {
            var isDirty = newValue !== this.state.currentPage;
            var formData = formGenerator.getFormData();
            formData[field.property] = newValue;
            formData[field.property + 'IsDirty'] = isDirty;
            formGenerator.updateFormData(formData);
        }
    }

    render() {
        var { formGenerator, field } = this.props;

        var fileType = substitute(field.settings?.type, formGenerator.props.controller, [formGenerator.getFormData()]);
        // if (fileType === 'js') fileType = 'javascript';
        var page = formGenerator.getFormData()[field.property] || this.getPage();
        if (typeof page !== 'string' && fileType === 'json') page = JSON.stringify(page, null, 1);

        var editorDidMount = (editor, monaco) => {
            this.editorRef.current = editor; // Store the editor instance
            // this.setState({ ...this.state, editor });
            var self = this;
            self.editor = editor;

            // // Add save functionality
            editor.addCommand(KeyMod.CtrlCmd | KeyCode.KEY_S, function () {
                if (field.settings && field.settings.onSave) {
                    var editorModal = editor.getModel();

                    var copyStack = deepCopy(self.props.collectionStack);
                    copyStack.reverse();

                    formGenerator.runActions(
                        field,
                        field.settings.onSave,
                        editorModal.getValue(),
                        formGenerator.getFormData(),
                        copyStack
                    );
                }
            });

            editor.goToLine = (lineNumber) => {
                this.editor.revealLine(lineNumber); // Scrolls to the line
                this.editor.setPosition({ lineNumber: lineNumber, column: 1 }); // Moves cursor
                // this.editor.focus(); // Puts focus on the editor
            };

            editor.selectPhrase = (phrase) => {
                const model = editor.getModel();
                if (!model) return;

                if (!phrase) return;

                // Find all occurrences of the phrase
                const matches = model.findMatches(phrase, false, false, false, null, true);

                if (matches.length === 0) return;

                // Convert matches into selections
                const selections = matches.map((match) => ({
                    selectionStartLineNumber: match.range.startLineNumber,
                    selectionStartColumn: match.range.startColumn,
                    positionLineNumber: match.range.endLineNumber,
                    positionColumn: match.range.endColumn,
                }));

                // Apply selections
                editor.setSelections(selections);
                //editor.focus();
            };

            editor.selectLine = (lineNumber) => {
                const model = editor.getModel();
                if (!model) return;
                const lineContent = model.getLineContent(lineNumber);
                const lineLength = lineContent.length + 1;

                if (lineNumber != null) {
                    editor.goToLine(lineNumber);
                }
                editor.setSelection({
                    startLineNumber: lineNumber,
                    startColumn: 1,
                    endLineNumber: lineNumber,
                    endColumn: lineLength,
                });

                // editor.focus();
            };

            editor.highlightPhrase = (phrase) => {
                const model = editor.getModel();
                if (!model) return;
                if (!phrase) return;

                // Find all occurrences of the phrase
                const matches = model.findMatches(phrase, false, false, false, null, true);

                if (matches.length === 0) return;

                // Create decorations for highlighting
                editor.decorations = editor.deltaDecorations(
                    editor.decorations ?? '',
                    matches.map((match) => ({
                        range: match.range,
                        options: {
                            inlineClassName: 'monaco-editor-highlight', // Applies CSS class for styling
                        },
                    }))
                );
            };

            editor.goToLineAndSelectPhrase = (lineNumber, phrase) => {
                editor.goToLine(lineNumber);
                setTimeout(() => editor.selectPhrase(phrase), 100); // Delay to ensure scrolling is applied first
            };

            editor.goToLineAndHighlightPhrase = (lineNumber, phrase) => {
                editor.goToLine(lineNumber);
                editor.selectLine(lineNumber);
                setTimeout(() => editor.highlightPhrase(phrase), 100); // Delay to ensure scrolling is applied first
            };
            // // added as undo didn't force onChange call every time
            editor.onDidChangeModelContent((a, b, c) => {
                var newValue = self.editor.getModel().getValue();
                this.handleEditorValueChange(newValue);
            });
        };

        var settings = field.settings || {};
        var options = { minimap: { enabled: true } };

        if (settings.options) {
            var copyStack = deepCopy(this.props.collectionStack);
            copyStack.reverse();
            options = substitute(settings.options, formGenerator.props.controller, [...copyStack, formGenerator.getFormData()]);
        }
        
        // options = {...options, wordWrap: 'on', wrappingIndent: 'indent', scrollBeyondLastLine: false};

        fileType = this.getMonacoLanguageFromExtension(fileType || settings.type || field.settings.language || 'json');
        console.log('fileType', fileType);

        if (this.editor) this.editor.layout();
        return (
            <ReactMonacoEditor
                id="xyz"
                className="monaco-wrapper"
                width={'100%'}
                height={'100%'}
                language={field.settings.language || fileType || 'json'}
                options={options}
                wordWrap={'on'}
                theme="light"
                value={page}
                key={`${this.editor?.editorWidth}-${this.editor?.editorHeight}`}
                //  onChange={(p) => this.handleEditorValueChange(p)}
                editorDidMount={editorDidMount}
                style={{ minWidth: '100%', maxHeight: '100%' }}></ReactMonacoEditor>
        );
    }

    
    getMonacoLanguageFromExtension(extension) {
  const ext = extension.startsWith('.') ? extension.slice(1).toLowerCase() : extension.toLowerCase();

        const extensionToLanguageMap = {
            javascript: 'javascript',
            js: 'javascript',
            mjs: 'javascript',
            ts: 'typescript',
            jsx: 'javascript',
            tsx: 'typescript',
            html: 'html',
            htm: 'html',
            css: 'css',
            json: 'json',
            less: 'less',
            scss: 'scss',
            xml: 'xml',
            md: 'markdown',
            markdown: 'markdown',
            py: 'python',
            php: 'php',
            rb: 'ruby',
            go: 'go',
            java: 'java',
            c: 'c',
            h: 'cpp',       // C headers often treated as C++
            cpp: 'cpp',
            cc: 'cpp',
            cs: 'csharp',
            sql: 'sql',
            sh: 'shell',
            bash: 'shell',
            bat: 'bat',
            ini: 'ini',
            cfg: 'ini',
            yaml: 'yaml',
            yml: 'yaml',
            toml: 'toml',
            swift: 'swift',
            r: 'r',
            dockerfile: 'dockerfile'
        };

        return extensionToLanguageMap[ext] || 'plaintext'; // Fallback
   }
}
